import { Injector } from '@angular/core';
import { RoblexInjector } from '../roblex.injector';

export class RoblexModalInjector extends RoblexInjector {
    /**
     * Creates an instance of roblex modal injector.
     * @param _parentInjector Injector
     * @param _additionalTokens WeakMap<any, any>
     */
    constructor(
        public _parentInjector: Injector,
        public _additionalTokens: WeakMap<any, any>
    ) {
        super(_parentInjector, _additionalTokens);
    }
}
